<template>
  <el-drawer :title="form.id ? '编辑' : '添加'" :visible.sync="drawer" :modal="true" :wrapperClosable="false" size="80%"
             @close="closeDrawer" :modal-append-to-body="false" :direction="direction">

    <!-- title -->
    <div class="drawer_form">
      <el-form :model="form" status-icon :rules="formRules" ref="form" label-width="120px" label-position="top"
               class="demo-ruleForm">
        <div class="form-content">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="first-level-form">
                <el-form-item label="评课标准名称" prop="templateName">
                  <el-input type="text" v-model="form.templateName" placeholder="请输入评课标准名称"
                            autocomplete="off" class="form-input" @blur="validateTemplateName"></el-input>
                </el-form-item>
                <el-form-item label="评课附加提示词" prop="">
                  <el-input type="textarea" rows="4" v-model="form.background"
                            placeholder="请输入评课附加提示词" autocomplete="off" class="form-textarea"></el-input>
                </el-form-item>

                <!-- 新增输入框和添加按钮 -->
                <el-form-item label="一级指标" prop="">
                  <div style="display: flex; gap: 10px; margin-bottom: 15px;">
                    <el-input v-model="newItemText" placeholder="请输入内容" style="flex: 1;"></el-input>
                    <el-button type="primary" @click="addItem">添加</el-button>
                  </div>

                  <!-- 数据表格 -->
                  <el-table ref="dataTable"
                            :data="indicatorItems.map(item => ({ name: item.name, maxScore: item.maxScore }))"
                            style="width: 100%" row-key="name" v-loading="false"
                            :highlight-current-row="false" :row-class-name="''"
                            :tree-props="{ hasChildren: false }">
                    <el-table-column align="center" prop="name" label="内容"></el-table-column>
                    <el-table-column align="center" label="分数" width="80">
                      <template slot-scope="scope">
                        {{ calculateFirstLevelScore(scope.row) }} <!-- 自动计算一级指标分数 -->
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="80">
                      <template slot-scope="scope">
                        <el-button @click="deleteItem(scope.row.name)" type="primary"
                                   size="small">删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="second-level-form">
                <el-form-item label="二级指标" prop="">
                  <!-- 输入框和添加按钮 -->
                  <div style="display: flex; gap: 10px; margin-bottom: 15px; flex-wrap: wrap;">
                    <el-select v-model="selectedFirstLevelId" placeholder="请选择一级指标"
                               style="width: 150px;" filterable>
                      <el-option v-for="item in indicatorItems" :key="item.name"
                                 :label="item.name" :value="item.name"></el-option>
                    </el-select>
                    <el-input v-model="newSecondItemText" placeholder="请输入二级指标内容"
                              style="flex: 1; min-width: 150px;"></el-input>
                    <el-button type="primary" @click="addSecondItem"
                               :disabled="!newSecondItemText.trim()">添加
                    </el-button>
                  </div>

                  <!-- 二级指标表格 -->
                  <el-table ref="secondLevelTable"
                            :data="flattenedSecondLevelItems().map(item => ({ name: item.name, firstLevelText: item.firstLevelText, maxScore: item.maxScore }))"
                            style="width: 100%" row-key="name"
                            :row-class-name="secondLevelTableRowClassName"
                            @current-change="handleSecondLevelCurrentChange" v-loading="false"
                            :highlight-current-row="true" :tree-props="{ hasChildren: false }">
                    <el-table-column align="center" label="一级指标">
                      <template slot-scope="scope">
                        {{ scope.row.firstLevelText }}
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="name" label="指标名称"></el-table-column>
                    <el-table-column align="center" label="分数" width="80">
                      <template slot-scope="scope">
                        {{ calculateSecondLevelScore(scope.row) }} <!-- 自动计算二级指标分数 -->
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="80">
                      <template slot-scope="scope">
                        <el-button @click="deleteSecondItem(scope.row.name)" type="primary"
                                   size="small">删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="10">
              <div class="third-level-form">
                <el-form-item label="三级指标" prop="">
                  <!-- 多选下拉框 - 自动填充表格 -->
                  <div style="margin-bottom: 15px;">
                    <el-select v-model="selectedThirdLevelRules" multiple collapse-tags
                               placeholder="请选择三级指标" style="width: 100%; min-width: 200px;" filterable
                               @change="onThirdLevelRulesChange">
                      <el-option v-for="rule in thirdLevelRules" :key="rule.id" :label="rule.name"
                                 :value="rule.id"></el-option>
                    </el-select>
                  </div>

                  <!-- 三级指标表格 -->
                  <el-table
                      :data="flattenedThirdLevelItems().map(item => ({ id: item.id, name: item.name, maxScore: item.maxScore, displayType: item.displayType || '1', width: item.width || 24 }))"
                      style="width: 100%" row-key="id" @current-change="handleThirdLevelCurrentChange"
                      v-loading="false" :highlight-current-row="true"
                      :tree-props="{ hasChildren: false }">
                    <el-table-column align="center" prop="name" label="指标名称"></el-table-column>
                    <el-table-column align="center" label="分数">
                      <template slot-scope="scope">
                        <el-input-number :value="scope.row.maxScore"
                                         @change="updateThirdLevelScore(scope.row.id, $event)" :min="1"
                                         :step="1" style="width: 100px;" size="small"></el-input-number>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="展示类型">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.displayType" style="width: 100px;"
                                   @change="updateThirdLevelDisplayType(scope.row.id, $event)">
                          <el-option label="分数" value="1"></el-option>
                          <el-option label="分|说" value="2"></el-option>
                          <el-option label="分|图" value="3"></el-option>
                          <el-option label="分|说|图" value="4"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="宽度占比">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.width"
                                   @change="updateThirdLevelWidth(scope.row.id, $event)"
                                   placeholder="请选择"
                                   size="small"
                                   style="width: 100px;">
                          <el-option label="6" :value="6"></el-option>
                          <el-option label="12" :value="12"></el-option>
                          <el-option label="24" :value="24"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="80">
                      <template slot-scope="scope">
                        <el-button @click="deleteThirdItem(scope.row.id)" type="primary"
                                   size="small">删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 底部按钮区域 -->
        <div class="form-footer">
          <el-button @click="closeDrawer" class="cancel-btn">取消</el-button>
          <el-button @click="onSubmit" type="primary" class="submit-btn" :disabled="!editable">
            {{ form.id ? '编辑' : '添加' }}
          </el-button>
        </div>
      </el-form>
      <!-- 编辑模式下，当不可编辑时显示蒙层 -->
      <div v-if="form.id && !editable" class="edit-overlay">
        <div class="edit-overlay-text">禁止编辑</div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import {save, rule_list, get_module, module_del_rule} from '@/request/api/module'

export default {
  components: {},
  watch: {
    // 监听三级指标分数变化，自动更新一二三级分数
    indicatorItems: {
      deep: true,
      handler() {
        // 触发依赖更新，Vue会自动重新计算计算属性
      }
    }
  },
  computed: {
    // 更新过滤后的二级指标（为兼容旧代码）
    filteredSecondLevelItems: function () {
      return this.flattenedSecondLevelItems();
    }
  },
  methods: {
    // 计算二级指标分数：当前二级下所有三级指标分数之和
    calculateSecondLevelScore(secondLevelItem) {
      // 查找原始二级指标对象
      let originalSecondLevel = null;
      for (const firstLevel of this.indicatorItems) {
        if (firstLevel.children) {
          originalSecondLevel = firstLevel.children.find(item => item.name === secondLevelItem.name);
          if (originalSecondLevel) break;
        }
      }

      if (!originalSecondLevel || !originalSecondLevel.children || originalSecondLevel.children.length === 0) {
        return 0;
      }
      return originalSecondLevel.children.reduce((total, thirdLevelItem) => {
        return total + (thirdLevelItem.maxScore || 0);
      }, 0);
    },
    // 计算一级指标分数：当前一级下所有二级指标分数之和
    calculateFirstLevelScore(firstLevelItem) {
      // 查找原始一级指标对象
      const originalFirstLevel = this.indicatorItems.find(item => item.name === firstLevelItem.name);
      if (!originalFirstLevel || !originalFirstLevel.children || originalFirstLevel.children.length === 0) {
        return 0;
      }
      return originalFirstLevel.children.reduce((total, secondLevelItem) => {
        return total + this.calculateSecondLevelScore(secondLevelItem);
      }, 0);
    },
    // 更新三级指标分数并触发联动更新
    updateThirdLevelScore(thirdLevelId, newScore) {
      // 遍历找到原始三级指标对象并更新分数
      for (const firstLevel of this.indicatorItems) {
        if (firstLevel.children) {
          for (const secondLevel of firstLevel.children) {
            if (secondLevel.children) {
              const thirdLevel = secondLevel.children.find(item => item.id === thirdLevelId);
              if (thirdLevel) {
                thirdLevel.maxScore = newScore;
                // 强制更新视图
                this.$forceUpdate();
                return;
              }
            }
          }
        }
      }
    },

    // 更新三级指标展示类型
    updateThirdLevelDisplayType(thirdLevelId, newType) {
      // 遍历找到原始三级指标对象并更新展示类型
      for (const firstLevel of this.indicatorItems) {
        if (firstLevel.children) {
          for (const secondLevel of firstLevel.children) {
            if (secondLevel.children) {
              const thirdLevel = secondLevel.children.find(item => item.id === thirdLevelId);
              if (thirdLevel) {
                thirdLevel.displayType = newType;
                // 强制更新视图
                this.$forceUpdate();
                return;
              }
            }
          }
        }
      }
    },

    // 更新三级指标宽度占比
    updateThirdLevelWidth(thirdLevelId, newWidth) {
      // 遍历找到原始三级指标对象并更新宽度占比
      for (const firstLevel of this.indicatorItems) {
        if (firstLevel.children) {
          for (const secondLevel of firstLevel.children) {
            if (secondLevel.children) {
              const thirdLevel = secondLevel.children.find(item => item.id === thirdLevelId);
              if (thirdLevel) {
                thirdLevel.width = newWidth;
                // 强制更新视图
                this.$forceUpdate();
                return;
              }
            }
          }
        }
      }
    },
    // 表格合并方法已移除，因为现在使用扁平化数据结构不需要合并

    // 提交数据（保留用于调试）
    submit() {
      console.log("最终提交数据：", this.formData);
      this.$message.success("已打印到控制台 ✅");
    },
    // 初始化数据
    init() {
      // 如果有id，则是编辑模式，需要获取数据
      if (this.form.id) {
        this.get_module_data()
      } else {
        // 从路由参数中获取level值
        const level = this.$route.query.level;
        if (level) {
          this.form.level = parseInt(level);
        }
      }
        this.get_rules()
    },
    // 获取模块数据（编辑模式使用）
    get_module_data() {
      get_module(this.form.id).then(res => {
        if (res.code === 0) {
          const data = res.data;

          // 单独设置每个字段，确保正确绑定
          this.form.templateName = data.templateName || '';
          this.form.background = data.background || '';
          this.form.rules = data.rules || [];
          // 设置是否可编辑状态
          this.editable = data.editable !== undefined ? data.editable : true;

          // 处理规则数据
          if (data.rules && data.rules.length > 0) {
            // 清空现有数据
            this.indicatorItems = [];

            // 处理三级嵌套结构
            data.rules.forEach(rule => {
              // 创建一级指标
              const firstLevelItem = {
                name: rule.name,
                maxScore: rule.maxScore || 0,
                children: []
              };

              // 处理二级指标
              if (rule.children && rule.children.length > 0) {
                rule.children.forEach(child => {
                  // 创建二级指标
                  const secondLevelItem = {
                    name: child.name,
                    maxScore: child.maxScore || 0,
                    parentName: rule.name,
                    children: []
                  };

                  // 处理三级指标
                  if (child.children && child.children.length > 0) {
                    child.children.forEach(grandChild => {
                      //     const thirdLevelItem = {
                      //         name: grandChild.name,
                      //         maxScore: grandChild.maxScore || 0,
                      //         parentName: child.name
                      //     };
                      secondLevelItem.children.push(grandChild);
                    });
                  }

                  firstLevelItem.children.push(secondLevelItem);
                });
              }

              this.indicatorItems.push(firstLevelItem);
            });

            // 不再需要更新ID，因为现在使用name作为标识
          }
        }
      });
    },

    // 不再需要updateMaxIds方法，因为现在使用name作为标识
    //指标列表
    get_rules() {
      return new Promise((resolve) => {
        rule_list({...this.rule_query, level: 3}).then(thirdRes => {
          this.thirdLevelRules = thirdRes.data
          console.log('三级指标加载完成:', this.thirdLevelRules)
          resolve()
        }).catch(() => {
          console.log('加载三级指标失败')
          resolve()
        })
      })
    },

    // 校验模板名称字段
    validateTemplateName() {
      this.$refs['form'].validateField('templateName', (errorMessage) => {
        console.log('模板名称校验结果:', errorMessage);
      });
    },

    // 提交表单
    onSubmit() {
      // 构建要提交的数据
      const submitData = {
        id: this.form.id || null,
        templateName: this.form.templateName,
        background: this.form.background,
        level: this.form.level || 3,
        rules: []
      };

      // 手动触发表单校验
      this.$refs['form'].validate((valid) => {
        console.log('表单校验结果:', valid);
        if (valid) {
          // 添加三级嵌套结构到规则数组
          this.indicatorItems.forEach(firstLevel => {
            const rule = {
              name: firstLevel.name,
              maxScore: this.calculateFirstLevelScore(firstLevel),
              type: 'first',
              children: []
            };

            // 添加二级指标
            firstLevel.children.forEach(secondLevel => {
              const secondRule = {
                name: secondLevel.name,
                maxScore: this.calculateSecondLevelScore(secondLevel),
                type: 'second',
                children: []
              };

              // 添加三级指标
              secondLevel.children.forEach(thirdLevel => {
                secondRule.children.push({
                  id: thirdLevel.id || null,
                  name: thirdLevel.name,
                  maxScore: thirdLevel.maxScore || 0,
                  type: 'third',
                  // 添加展示类型和宽度占比字段
                  displayType: thirdLevel.displayType || '1',
                  width: thirdLevel.width || 24,
                  agentCode: thirdLevel.agentCode || '',
                  code: thirdLevel.code || '',
                  isSys: thirdLevel.isSys || false,
                });
              });

              rule.children.push(secondRule);
            });

            submitData.rules.push(rule);
          });

          console.log('提交数据:', submitData);

          // 调用API提交数据
          if (this.form.id) {
            // 编辑模式
            save(submitData).then(res => {
              if (res.code === 0) {
                this.$message.success('编辑成功');
                this.closeDrawer();
              } else {
                this.$message.error(res.message || '编辑失败');
              }
            });
          } else {
            // 新增模式
            save(submitData).then(res => {
              if (res.code === 0) {
                this.$message.success('新增成功');
                this.closeDrawer();
              } else {
                this.$message.error(res.message || '新增失败');
              }
            });
          }
        }
      });
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //关闭抽屉
    closeDrawer() {
      this.$router.go(-1)
    },

    // 添加一级指标
    addItem() {
      if (!this.newItemText.trim()) {
        this.$message.warning('请输入一级指标内容');
        return;
      }

      // 创建新的一级指标，包含children数组用于存储二级指标
      const newItem = {
        name: this.newItemText.trim(),
        maxScore: 0, // 默认分数为0
        children: [] // 用于存储二级指标的数组
      };

      // 添加到一级指标数组中
      this.indicatorItems.push(newItem);

      // 清空输入框
      this.newItemText = '';

      // 不需要选中状态，所以不设置currentFirstLevelId
      // 但需要设置selectedFirstLevelId以便用户能继续添加二级指标
      this.selectedFirstLevelId = newItem.name; // 使用name作为标识
    },

    // 删除一级指标
    deleteItem(name) {
      const index = this.indicatorItems.findIndex(item => item.name === name);
      if (index > -1) {
        // 删除数据项
        this.indicatorItems.splice(index, 1);

        // 清除相关选中状态
        if (this.selectedFirstLevelId === name) {
          this.selectedFirstLevelId = null;
          this.currentFirstLevelId = null;
        }
        // 清除相关的二级指标选中状态
        this.selectedSecondLevelId = null;
        this.currentSecondLevelId = null;
        this.currentThirdLevelId = null;
      }
    },

    // 获取一级指标文本
    getFirstLevelItemText(name) {
      // 添加name参数的空值检查
      if (!name) {
        return '';
      }
      const item = this.indicatorItems.find(item => item.name === name);
      return item ? item.name : '';
    },

    // 移除一级指标选中效果的相关方法
    // handleCurrentChange 方法已移除，因为一级指标不需要选中效果


    // 添加二级指标
    addSecondItem() {
      // 验证输入
      if (!this.newSecondItemText.trim()) {
        this.$message.warning('请输入二级指标内容');
        return;
      }

      // 验证是否选择了一级指标
      if (!this.selectedFirstLevelId) {
        if (this.indicatorItems.length > 0) {
          // 如果没有选择但有一级指标，默认使用第一个
          this.selectedFirstLevelId = this.indicatorItems[0].name;
        } else {
          this.$message.warning('请先添加一级指标');
          return;
        }
      }

      // 查找对应的一级指标
      const firstLevelItem = this.indicatorItems.find(item => item.name === this.selectedFirstLevelId);
      if (!firstLevelItem) {
        this.$message.warning('找不到对应的一级指标');
        return;
      }

      // 创建新的二级指标，包含children数组用于存储三级指标
      const newItem = {
        name: this.newSecondItemText.trim(),
        maxScore: 0, // 默认分数为0
        parentName: this.selectedFirstLevelId, // 关联到选中的一级指标
        children: [] // 用于存储三级指标的数组
      };

      // 添加到对应的一级指标的children数组中
      firstLevelItem.children.push(newItem);

      // 清空输入框
      this.newSecondItemText = '';

      // 更新选中状态
      this.currentSecondLevelId = newItem.name;
      this.selectedSecondLevelId = newItem.name;
    },

    // 三级指标选择变更事件处理 - 自动填充表格
    onThirdLevelRulesChange() {
      // 验证是否选择了二级指标
      if (!this.selectedSecondLevelId) {
        this.$message.warning('请先选择二级指标');
        this.selectedThirdLevelRules = [];
        return;
      }

      // 查找对应的二级指标
      let secondLevelItem = null;
      for (const firstLevel of this.indicatorItems) {
        secondLevelItem = firstLevel.children.find(item => item.name === this.selectedSecondLevelId);
        if (secondLevelItem) {
          break;
        }
      }

      if (!secondLevelItem) {
        this.$message.warning('找不到对应的二级指标');
        return;
      }

      // 获取当前选中的三级指标ID集合
      const selectedRuleIds = new Set(this.selectedThirdLevelRules);

      // 过滤出需要保留的三级指标（那些id在选中集合中的）
      if (secondLevelItem.children) {
        // 只保留id在选中集合中的项
        secondLevelItem.children = secondLevelItem.children.filter(item =>
            selectedRuleIds.has(item.id)
        );
      } else {
        secondLevelItem.children = [];
      }

      // 添加新选择但尚未添加的三级指标
      selectedRuleIds.forEach(ruleId => {
        // 检查该规则是否已经在children中
        const exists = secondLevelItem.children.some(
            item => item.id === ruleId
        );

        if (!exists) {
          // 从thirdLevelRules中找到对应的rule对象
          const rule = this.thirdLevelRules.find(r => r.id === ruleId);
          if (rule) {
            // 创建新的三级指标，使用指标集合中的id作为主键
            const newItem = {
              id: rule.id, // 使用原始规则的id，不再使用自己生成的id
              name: rule.name,
              maxScore: rule.maxScore || 0,
              parentId: this.selectedSecondLevelId, // 关联到选中的二级指标
              agentCode: rule.agentCode,
              // 添加展示类型和宽度占比字段
              displayType: '1',
              width: 24,
              isSys: rule.isSys,
              code: rule.code,
            };

            // 添加到对应的二级指标的children数组中
            secondLevelItem.children.push(newItem);

            // 更新最后一个添加项的选中状态
            this.currentThirdLevelId = newItem.id;
          }
        }
      });
    },

    // 删除二级指标
    deleteSecondItem(name) {
      // 遍历所有一级指标查找对应的二级指标
      for (const firstLevelItem of this.indicatorItems) {
        const index = firstLevelItem.children.findIndex(item => item.name === name);
        if (index > -1) {
          // 删除数据项
          firstLevelItem.children.splice(index, 1);

          // 清除相关选中状态
          if (this.selectedSecondLevelId === name) {
            this.selectedSecondLevelId = null;
            this.currentSecondLevelId = null;
          }
          // 清除三级指标选中状态
          this.currentThirdLevelId = null;

          return;
        }
      }
    },

    // 删除三级指标
    deleteThirdItem(id) {
      // 遍历所有一级和二级指标查找对应的三级指标
      for (const firstLevelItem of this.indicatorItems) {
        for (const secondLevelItem of firstLevelItem.children) {
          const index = secondLevelItem.children.findIndex(item => item.id === id);
          if (index > -1) {
            // 删除数据项
            secondLevelItem.children.splice(index, 1);

            // 清除相关选中状态
            if (this.currentThirdLevelId === id) {
              this.currentThirdLevelId = null;
            }

            // 同时从selectedThirdLevelRules中移除对应的id
            const ruleIndex = this.selectedThirdLevelRules.indexOf(id);
            if (ruleIndex > -1) {
              this.selectedThirdLevelRules.splice(ruleIndex, 1);
            }

            return;
          }
        }
      }
    },

    // 处理二级指标行样式
    secondLevelTableRowClassName({row}) {
      return row.name === this.currentSecondLevelId ? 'current-row' : '';
    },

    // 一级指标行样式（不显示选中效果）
    tableRowClassName() {
      return '';
    },

    // 处理二级指标当前行变化
    handleSecondLevelCurrentChange(currentRow) {
      this.currentSecondLevelId = currentRow ? currentRow.name : null;
      this.selectedSecondLevelId = currentRow ? currentRow.name : null;
      // 清除三级指标选中状态
      this.currentThirdLevelId = null;

      // 获取筛选后的三级指标
      const filteredRules = this.filteredThirdLevelRules();

      // 查找当前二级指标下已存在的三级指标
      let secondLevelItem = null;
      for (const firstLevel of this.indicatorItems) {
        secondLevelItem = firstLevel.children.find(item => item.name === this.selectedSecondLevelId);
        if (secondLevelItem) {
          break;
        }
      }

      // 根据已存在的三级指标来设置选中状态
      if (secondLevelItem && secondLevelItem.children) {
        const existingRuleIds = new Set(secondLevelItem.children.map(item => item.id));
        // 只选中那些已经存在的三级指标的id
        this.selectedThirdLevelRules = Array.from(existingRuleIds);
      } else {
        // 如果没有已存在的三级指标，则不选中任何项
        this.selectedThirdLevelRules = [];
      }
      // 不再手动触发onThirdLevelRulesChange，避免覆盖已有数据
    },

    // 根据选中的二级指标过滤三级指标
    filteredThirdLevelRules() {
      if (!this.selectedSecondLevelId) {
        return [];
      }

      // 安全地调用filter方法
      return this.thirdLevelRules && Array.isArray(this.thirdLevelRules) ?
          this.thirdLevelRules.filter(
              thirdRule => thirdRule &&
                  (thirdRule.parentId === this.selectedSecondLevelId ||
                      (thirdRule.relation && Array.isArray(thirdRule.relation) &&
                          thirdRule.relation.includes(this.selectedSecondLevelId)))
          ) : [];
    },

    // 处理三级指标当前行变化
    handleThirdLevelCurrentChange(currentRow) {
      this.currentThirdLevelId = currentRow ? currentRow.id : null;
    },

    // 扁平化二级指标数据用于表格显示
    flattenedSecondLevelItems() {
      const items = [];
      this.indicatorItems.forEach(firstLevel => {
        firstLevel.children.forEach(secondLevel => {
          items.push({
            ...secondLevel,
            firstLevelText: firstLevel.name
          });
        });
      });
      return items;
    },

    // 扁平化三级指标数据用于表格显示 - 只显示当前选中二级指标下的三级指标
    flattenedThirdLevelItems() {
      const items = [];
      // 只有当选中了二级指标时才返回其下的三级指标
      if (this.selectedSecondLevelId) {
        this.indicatorItems.forEach(firstLevel => {
          const selectedSecondLevel = firstLevel.children.find(secondLevel => secondLevel.name === this.selectedSecondLevelId);
          if (selectedSecondLevel && selectedSecondLevel.children) {
            selectedSecondLevel.children.forEach(thirdLevel => {
              items.push({
                ...thirdLevel,
                firstLevelText: firstLevel.name,
                secondLevelText: selectedSecondLevel.name
              });
            });
          }
        });
      }
      return items;
    },

    // 获取过滤后的二级指标（根据选中的一级指标）
    getFilteredSecondLevelItems() {
      // 因为一级指标不需要选中效果，所以根据selectedFirstLevelId获取二级指标
      const firstLevel = this.indicatorItems.find(item => item.name === this.selectedFirstLevelId);
      return firstLevel ? firstLevel.children : [];
    },

    // 获取选中的二级指标文本
    getSelectedSecondLevelText() {
      for (const firstLevel of this.indicatorItems) {
        const secondLevel = firstLevel.children.find(item => item.name === this.selectedSecondLevelId);
        if (secondLevel) {
          return `${firstLevel.name} - ${secondLevel.name}`;
        }
      }
      return '';
    },

    //
  },
  data() {
    return {
      drawer: true, //表单
      direction: 'rtl',//抽屉方向
      loading: false,
      form: {
        id: '',
        templateName: '', //名称
        background: '',//文化背景
        level: 3,
        rules: []
      },
      rule_query: {name: ''},
      secondLevelRules: [],//二级指标
      thirdLevelRules: [],//三级指标
      editable: true, //判断指标项是否可编辑
      formRules: {
        templateName: [
          {required: true, message: '名称必填', trigger: ['blur', 'change']}
        ]
      },
      // 三级嵌套结构的评课指标数据
      newItemText: '', // 新增一级指标输入框的值
      indicatorItems: [], // 一级指标数组，包含嵌套的二三级指标
      currentFirstLevelId: null, // 当前选中的一级指标ID（暂时保留以兼容其他功能）
      currentSecondLevelId: null, // 当前选中的二级指标ID
      currentThirdLevelId: null, // 当前选中的三级指标ID
      // 不再需要生成ID的计数器，因为现在使用name作为标识
      nextThirdId: 1, // 只保留三级指标的计数器（如果需要）
      // 二级指标相关数据
      newSecondItemText: '', // 二级指标输入框的值
      selectedFirstLevelId: null, // 选中的一级指标ID
      // 三级指标相关数据
      newThirdItemText: '', // 三级指标输入框的值
      selectedSecondLevelId: null, // 选中的二级指标ID
      selectedThirdLevelRules: [] // 选中的三级指标规则数组
    };
  },
  created() {
    this.form.id = this.$route.query.id || ''
    this.init()
  },
}


</script>


<style lang="less" scoped>
// 全局样式重置，确保所有元素使用box-sizing
* {
  box-sizing: border-box;
}

.first-level-form {
  display: flex;
  flex-direction: column;
}

.second-level-form {
}

.third-level-form {

  .el-input-number__decrease,
  .el-input-number__increase {
    font-size: 10px !important;
    width: 20px !important;
  }

  /deep/ .el-input-number__decrease {
    font-size: 10px;
    width: 28px;
    background: none;
    color: white;
    background: #409EFF;
    border: none;
  }

  /deep/ .el-input-number__increase {
    font-size: 10px;
    width: 28px;
    background: #409EFF;
    color: white;
    border: none;
  }
}

// 整个抽屉内容容器
.drawer_form {
  width: 100%;
  height: 100%;
  padding: 0;
  position: relative;
  overflow: hidden;
}

// 表单容器
.demo-ruleForm {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
}

// 表单内容区域（可滚动部分）
.form-content {
  flex: 1;
  overflow-y: auto;
  padding: 0 20px;
  margin-bottom: 80px; // 为底部按钮留出空间
  width: 100%;

  // 自定义滚动条
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 123, 255, 0.1);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 123, 255, 0.5);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 123, 255, 0.7);
  }
}

// 章节标题
.section-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  display: block;
  margin-bottom: 10px;
  clear: both; // 确保标题总是新的一行开始
}

// 表单区域样式
.form-section {
  width: 100%;
  margin-bottom: 20px;
  padding: 15px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(0, 123, 255, 0.3);
  box-sizing: border-box;
  position: relative; // 为蒙层提供定位参考
}

// 表单元素样式
.form-input,
.form-select,
.form-textarea {
  width: 100%;
  border-radius: 4px;
  transition: all 0.3s;

  &:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

// 编辑模式下的蒙层样式
.edit-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  pointer-events: all;
  user-select: none;
  border-radius: 10px;

  .edit-overlay-text {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  }
}

// 添加卡片包装器，确保点击区域完全可用
.add-card-wrapper {
  position: relative;
  z-index: 20; // 高于其他元素
  width: 100%;
}

// 添加卡片样式
.add-card {
  margin: 15px 0;
  text-align: center;
  cursor: pointer;
  user-select: none;
  border: 2px dashed #007bff;
  background-color: transparent;
  color: #007bff;
  transition: all 0.3s;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  z-index: 15; // 确保卡片在最上层

  // 确保整个卡片都是可点击的
  &:deep(.el-card__body) {
    cursor: pointer;
  }

  &:hover {
    background-color: rgba(0, 123, 255, 0.1);
    border-color: #409eff;
    transform: translateY(-2px);
  }

  .add-card-content {
    // padding: 20px 0;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
  }
}

// 备用添加按钮样式
.backup-add-btn {
  margin: 10px 0;
  width: 100%;
  position: relative;
  z-index: 20;
}

// 规则卡片样式
.rule-card {
  margin: 15px 0;
  // background-color: rgba(255, 255, 255, 0.1); // 增加背景不透明度以提高可见度
  background: none;
  border: 1px solid #007bff; // 更粗的边框使其更明显
  border-radius: 8px;
  overflow: visible; // 允许内容完全显示
  position: relative;
  z-index: 5; // 确保新增的规则卡片可见
  opacity: 1; // 确保完全不透明
  display: block; // 确保是块级元素
  min-height: 200px; // 设置最小高度确保可见
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2); // 添加阴影增强立体感
  transition: all 0.3s ease; // 添加过渡效果

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 123, 255, 0.3); // 悬停时增强阴影
    border-color: #409eff; // 悬停时边框变色
  }
}

// 分组头部样式
.group-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;

  .group-name-input {
    flex: 1;
  }

  .delete-btn {
    padding: 4px 12px;
  }
}

// 选择器容器样式
.select-container {
  margin-bottom: 12px;

  .rule-select {
    width: 100%;
  }
}

// 表格样式
.score-table {
  background-color: transparent;

  &::before,
  &::after {
    display: none;
  }

  .table-column {
    background-color: transparent;
    color: #fff;
  }
}

// 分数输入框样式
.score-input {
  width: 100px;
  text-align: center;
}

// 表格选中行样式
.current-row {
  background-color: rgba(0, 123, 255, 0.5) !important;
}

// 底部按钮区域
.form-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background-color: #052445;
  border-top: 1px solid rgba(0, 123, 255, 0.3);
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  box-sizing: border-box;
  z-index: 100;

  .cancel-btn,
  .submit-btn {
    min-width: 100px;
    padding: 8px 20px;
    font-size: 14px;
    border-radius: 4px;
  }

  .submit-btn {
    background-color: #007bff;
    border-color: #007bff;

    &:hover {
      background-color: #409eff;
      border-color: #409eff;
    }
  }
}


.form-section-title {
  font-size: 14px;
  color: #7ba8d0;
  margin-top: 10px;
  margin-bottom: 10px;
}

/deep/ .el-collapse-item {
  border: 1px solid #007bff;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 0 10px;
}

/deep/ .el-collapse-item__header {
  background: none;
  border: none;
  color: #7ba8d0 !important;
}

/deep/ .el-collapse-item__wrap {
  background: none;
  border: none;
}

/deep/ .el-collapse {
  border: none;
  padding: 0;
  color: #7ba8d0 !important;
}

// Element UI 组件覆盖样式
/deep/ .el-form-item {
  margin-bottom: 20px;
}

/deep/ .el-form-item__label {
  color: #fff;
  font-weight: 500;
}

/deep/ .el-table__header-wrapper th {
  background-color: transparent;
  color: #fff;
  border-bottom: 1px solid rgba(0, 123, 255, 0.3);
}

/deep/ .el-table__body-wrapper td {
  background-color: transparent;
}

// 选中行样式
.current-row {
  background-color: rgba(0, 123, 255, 0.5) !important;
}

/deep/ .el-table__body tr.current-row > td {
  background-color: rgba(0, 123, 255, 0.5) !important;
  color: #fff;
  border-bottom: 1px solid rgba(0, 123, 255, 0.1);
}

/deep/ .el-table__row:hover td {
  background-color: rgba(0, 123, 255, 0.1);
}

/deep/ .el-card__header {
  padding: 15px;
  background-color: rgba(0, 123, 255, 0.1);
  border-bottom: 1px solid rgba(0, 123, 255, 0.3);
}

/deep/ .el-card__body {
  padding: 15px;
}

/deep/ .el-tabs__header {
  background: none;
}

/deep/ .el-tabs--border-card {
  background: none;
  border: 1px solid #007bff;
  // border: none;
}

/deep/ .el-tabs__item {
  background: none;
  border: none;
}

/deep/ .el-tabs--border-card > .is-active {
  background: none !important;
  border: none !important;

}

/deep/ .el-divider--horizontal {
  margin: 0 0 20px 0;
  background: #007bff;
}
</style>
